"use client";

import dynamic from "next/dynamic";

const BubblesClient = dynamic(() => import("./BubblesClient"), { ssr: false });

export default function BubblesPage() {
  return <BubblesClient />;
}
